<template>
  <div class="com-page">
    <el-container>
      <el-header>
        <div class="logo">
          <span>{{ui.appName}}</span>
          {{ui.appVersion}}
        </div>
        <div class="userinfo">
          <el-dropdown>
            <span>
              <el-icon><Avatar /></el-icon>
              {{ui.adminName}}
              <el-icon class="down"><ArrowDown /></el-icon>
            </span>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item @click="editPwd">修改密码</el-dropdown-item>
                <el-dropdown-item @click="logout" >退出系统</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </el-header>
      <el-container id='elmain'>
        <el-aside :class="[isCollapse ? 'menu-collapse-width' : 'menu-expand-width']">
          <div @click="changeCollapse()" class="collapseIcon">
            <span class="arrow">
              <el-icon><DArrowRight v-if="isCollapse" /><DArrowLeft v-else /></el-icon>
            </span>
            <span class="arrow-text">导航菜单</span>
          </div>
          <el-menu v-loading="loading" :default-active="$route.path" unique-opened :collapse="isCollapse">
            <!-- 循环数据格式 -->
            <el-sub-menu :index="`${menu.id}`" v-for="(menu,index) in menuData" :key="index">
              <template #title>
                <component :is="menu.icon" class="icon" ></component>
                <span>{{menu.name}}</span>
              </template>
              <div v-for="item1 in menu.menuItem" :key="item1.index">
                <el-sub-menu v-if="item1.menuItem.length > 0" :index="`${item1.id}`">
                  <template #title>{{item1.name}}</template>
                  <div v-for="item2 in item1.menuItem" :key="item2.index">
                    <el-sub-menu v-if="item2.menuItem.length > 0" :index="`${item2.id}`">
                      <template #title>{{item2.name}}</template>
                      <el-menu-item :index="item3.path" v-for="item3 in item2.menuItem" :key="item3.index" @click="menuClick(item3)">{{item3.name}}</el-menu-item>
                    </el-sub-menu>
                    <el-menu-item v-else :index="item2.path" @click="menuClick(item2)">{{item2.name}}</el-menu-item>
                  </div>
                </el-sub-menu>
                <el-menu-item v-else :index="item1.path" @click="menuClick(item1)">{{item1.name}}</el-menu-item>
              </div>
            </el-sub-menu>
          </el-menu>
        </el-aside>
        <el-main>
          <el-tabs v-model="activeTab"
            type="card" @tab-remove="removeTab"
            @tab-click="tabClick">
            <el-tab-pane
              v-for="item in tabsItem" :key="item.name" :label="item.label"
              :name="item.name" :closable="item.closable">
            </el-tab-pane>
          </el-tabs>
          <router-view v-slot="{ Component }">
            <keep-alive :include="includePages">
              <component :clientHeight="clientHeight" :is="Component" :key="$route.Path" v-if="$route.meta.keepAlive" />
            </keep-alive>
            <component :is="Component" v-if="!$route.meta.keepAlive" />
          </router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
  <!-- 修改密码对话框 -->
  <el-dialog title="修改密码" v-model="dialogPwdVisible" :close-on-click-modal="false">
    <el-form ref="formPwd" :model="form" :rules="rules" label-width="130px">
      <el-form-item label="原密码" prop="oldPwd">
        <el-input type="password" v-model="form.oldPwd" show-password placeholder="请输入原密码" class="width"></el-input>
      </el-form-item>
      <el-form-item label="新密码" prop="newPwd">
          <el-input type="password" v-model="form.newPwd" show-password placeholder="请输入新密码" class="width"></el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="reNewPwd">
          <el-input type="password" v-model="form.reNewPwd" show-password placeholder="请输入确认密码" class="width"></el-input>
      </el-form-item>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="closeForm">关 闭</el-button>
        <el-button type="primary" @click="savePwd">确 定</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: 'Home',
  data () {
    var validatePass = (rule, value, callback) => {
      if (value !== this.form.newPwd) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      clientHeight: document.body.clientHeight,
      isCollapse: false,
      loading: false,
      // includePages: [],
      menuData: [],
      // 选中选项卡的name
      // activeTab: '/user/index',
      // activePath: '',
      // tabIndex: 1,
      // 默认首页 菜单中的name=tabsItem中的label=组件名
      // tabsItem: [
      //   {
      //     label: '首页',
      //     name: '/user/index',
      //     closable: false,
      //     content: '首页 content'
      //   }
      // ]
      ui: {
        adminName: '',
        appName: '',
        appVersion: ''
      },
      form: {
        oldpwd: '',
        newpwd: '',
        reNewpwd: ''
      },
      rules: {
        oldPwd: [
          { required: true, message: '请输入原密码', trigger: 'blur' }
        ],
        newPwd: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
        ],
        reNewPwd: [
          { required: true, message: '请输入确认密码', trigger: 'blur' },
          { validator: validatePass, trigger: 'blur' }
        ]
      },
      dialogPwdVisible: false
    }
  },
  components: {
    // HelloWorld
  },
  mounted () {
    this.getMainHeight()
    // 监听window窗口大小变化
    window.addEventListener('resize', this.getMainHeight)
    this.ui = this.$api.ui
    if (this.ui == null) {
      this.$router.push({ path: '/login' })
    }
    this.menuClick()
    this.getData()
  },
  unmount () {
    window.removeEventListener('resize', this.getMainHeight)
  },
  computed: {
    // 当前激活的导航
    // activeNav () {
    //   return this.$route.path
    // }
    tabsItem: {
      get () {
        // console.log('tabsPage=get', this.$store.state.tabsPage)
        return this.$store.state.tabsPage
      },
      set (val) {
        // console.log('tabsPage=set', val)
        this.$store.state.tabsPage = val
      }
    },
    activeTab: {
      get () {
        // console.log('TabsValue=get', this.$store.state.tabsValue)
        return this.$store.state.tabsValue
      },
      set (val) {
        // console.log('TabsValue=set', val)
        this.$store.state.tabsValue = val
      }
    },
    // keep-alive 中的include组件名
    includePages: {
      get () {
        const tabs = this.$store.state.tabsPage
        const arr = tabs.map(a => a.name.replace(/\//g, ''))
        // console.log('arrget=', arr.toString())
        return arr.toString()
      }
    }
  },
  methods: {
    // main高 = 网页可见区域高 - el-header高
    getMainHeight () {
      if (window.innerHeight) {
        this.clientHeight = window.innerHeight - 60
      } else if ((document.body) && (document.body.clientHeight)) {
        this.clientHeight = document.body.clientHeight - 60
      }
      document.getElementById('elmain').style.height = this.clientHeight + 'px'
    },
    changeCollapse () {
      this.isCollapse = !this.isCollapse
    },
    // 调用 注册vuex内注册的editableTabs方法
    ...mapActions({
      menuClick: 'editableTabs'
    }),
    ...mapState(['includePageName']),
    // menuClick (item) {
    //   this.addTab(item)
    //   // 路由跳转
    //   this.$router.push({
    //     path: item.path
    //     // query: { t: +new Date() }
    //   })
    // },
    // addTab (menu) {
    //   const tabs = this.tabsItem
    //   // tabs中是否已存在菜单项
    //   var exist = tabs.some(item => item.name === menu.path)
    //   // 如不存在就添加新选项卡
    //   if (!exist) {
    //     this.tabsItem.push({
    //       label: menu.name,
    //       // name: newTabName,
    //       name: menu.path,
    //       closable: true
    //     })
    //   }
    //   this.activeTab = menu.path
    // },
    tabRouter (obj) {
      // console.log('tabobj=', obj)
      // 跳转
      this.$router.push({
        // path: path
        path: obj.path,
        name: obj.code,
        params: { qx: obj.qx }
      })
    },
    removeTab (targetName) {
      const tabs = this.tabsItem
      let activeName = this.activeTab
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            const nextTab = tabs[index + 1] || tabs[index - 1]
            if (nextTab) {
              activeName = nextTab.name
              // console.log('thisTab', nextTab)
              this.tabRouter(nextTab)
              // this.$router.push({ path: nextTab.name })
            }
          }
        })
      }
      this.activeTab = activeName
      this.tabsItem = tabs.filter((tab) => tab.name !== targetName)
    },
    tabClick (thisTab) {
      const path = thisTab.props.name
      this.tabsItem.some((v) => {
        if (v.name === path) {
          this.tabRouter(v)
          return true
        }
      })
    },
    // keep-alive 中的include组件名添加、删除操作
    addInclude (to, from) {
      // 添加
      const pages = this.includePages
      var exist = pages.some(p => p === to.name)
      if (!exist) {
        pages.push(to.name)
        this.includePages = pages
      }
      // 删除
      const tabs = this.tabsItem
      var exist1 = tabs.some(tab => tab.name === from.path)
      // 标签页不存在就删除include中该页组件
      if (!exist1) {
        const pages = this.includePages
        this.includePages = pages.filter((p) => p !== from.name)
      }
    },
    // removeInclude (from) {
    //   const tabs = this.tabsItem
    //   var exist = tabs.some(tab => tab.name === from.path)
    //   // 标签页不存在就删除include中该页组件
    //   if (!exist) {
    //     const pages = this.includePages
    //     this. includePages = pages.filter((p) => p !== from.name)
    //   }
    // }
    async getData () {
      // this.loading = true
      const { data: ret } = await this.$http.get(this.$api.modulenavmenu)
      if (ret.status === 0) {
        if (ret.data === null) {
          this.$message({
            message: ret.message,
            type: 'warning'
          })
          return
        }
        this.menuData = ret.data
        // console.log('this.menuData=', this.menuData)
      }
      // this.loading = false
    },
    async logout () {
      const { data: ret } = await this.$http.post(this.$api.logout)
      if (ret.status === 3) {
        this.$message.success(ret.message)
        this.$storage.remove('xudaqtoken')
        this.$router.replace('/login')
      } else {
        this.$message.error(ret.message)
      }
    },
    editPwd () {
      this.dialogPwdVisible = true
    },
    savePwd () {
      this.$refs.formPwd.validate(async (valid) => {
        if (valid) {
          // console.log(this.form)
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          const { data: ret } = await this.$http.post(this.$api.savepwd, this.form)
          if (ret.status === 0) {
            this.$message.success(ret.message)
            this.closeForm()
          } else {
            this.$message.error(ret.message)
          }
          loading.close()
        } else {
          this.$message.error('验证没通过。')
          return false
        }
      })
    },
    resetForm () {
      this.$refs.formPwd.resetFields()
    },
    closeForm () {
      this.$refs.formPwd.resetFields()
      this.dialogPwdVisible = false
    }
  },
  watch: {
    $route (to, from) {
      // console.log('from=', from)
      // console.log('to=', to)
      // console.log('this.tabsItem=', this.tabsItem)
      // this.addInclude(to, from)
      // console.log('includePages=', this.includePages.toString())
      // // 非菜单点击,缓存页面
      // if (to.fullPath === to.path) {
      //   this.$route.meta.keepAlive = true
      // } else {
      //   this.$nextTick(function () {
      //     this.$route.meta.keepAlive = true
      //   })
      // }
    }
    // $route (to) {
    //   console.log('watchto=', to)
    //   if (this.$route.meta.keepAlive === true) {
    //     this.$route.meta.keepAlive = false
    //   }
    // }
    // 监听路由的变化，动态生成tabs
    // $route: function (to) {
    //   // console.log(to)
    //   let flag = true // 判断是否需要新增页面
    //   const path = to.path
    //   if (Object.keys(to.meta).length !== 0) {
    //     // console.log(this.$refs.tabs)
    //     for (let i = 0; i < this.$refs.tabs.length; i++) {
    //       // 首页不判断 如果页面已存在，则直接定位当页面，否则新增tab页面
    //       if (i !== 0) {
    //         if (this.$refs.tabs[i].label === to.meta.name) {
    //           // 定位到已打开页面
    //           this.activeTab = this.$refs.tabs[i].name
    //           flag = false
    //           break
    //         }
    //       }
    //     }
    //     // 新增页面
    //     if (flag) {
    //       // 获得路由元数据的name和组件名
    //       const thisName = to.meta.name
    //       const thisComp = to.meta.comp
    //       // 对tabs的当前激活下标和tabs数量进行自加
    //       const newActiveIndex = ++this.tabIndex + ''
    //       // 动态双向追加tabs
    //       this.tabsItem.push({
    //         title: thisName,
    //         name: String(newActiveIndex),
    //         closable: true,
    //         ref: 'tabs',
    //         content: thisComp
    //       })
    //       this.activeTab = newActiveIndex
    //       /*
    //       * 当添加tabs的时候，把当前tabs的name作为key，path作为value存入tabsPath数组中
    //       * key:tabs的name
    //       * value:tabs的path
    //       * {
    //       *   key: name,
    //       *   value: path
    //       * }
    //       * ///后面需要得到当前tabs的时候可以通过当前tabs的name获得path
    //       * */
    //       if (this.tabsPath.indexOf(path) === -1) {
    //         this.tabsPath.push({
    //           name: newActiveIndex,
    //           path: path
    //         })
    //       }
    //     }
    //   }
    // }
  }
}
</script>
<style lang="less" scoped>
@BrandColor: #409EFF;
@Success: #67C23A;
@Warning: #E6A23C;
@Danger: #F56C6C;
@Info: #909399;
@Black: #000000;
@White: #FFFFFF;
@PrimaryText: #303133;
@RegularText: #606266;
@SecondaryText: #909399;
@PlaceholderText: #C0C4CC;
@BaseBorder: #DCDFE6;
@LightBorder: #E4E7ED;
@LighterBorder: #EBEEF5;
@ExtraLightBorder: #F2F6FC;

.el-container {
  // margin-bottom: 40px;
  height: 100%;
}
.el-header,
.el-footer {
  background-color: @BrandColor;
  // color: var(--el-text-color-primary);
  color: @White;
  // text-align: center;
  height: 60px;
  line-height: 60px;
}

.el-aside {
  background-color: #d3dce6;
  color: @PrimaryText;
  // width: 200px;
  // text-align: center;
}
.menu-expand-width {
  width: 200px;
}
.menu-collapse-width {
  width: 50px;
}
.collapseIcon{
  background-color: @RegularText;
  color: @White;
  font-size: 14px;
  height: 30px;
  line-height: 30px;
  overflow: hidden;
  .arrow {
    padding: 0 8px 0 22px;
    cursor: pointer;
    vertical-align:middle;
  }
}
.el-menu {
  background-color: #d3dce6;
}

.el-main {
  padding: 4px 5px;
  background-color: @White;
  // border: 1px solid @Danger;
  // height: 95%;
  .el-tabs {
    .el-tab-pane {
      background-color: #1866be;
    }
  }
}
// .el-header div{
//   display:table-cell;
//   border: 1px solid @Danger;
// }
.logo{
  float: left;
  span {
    float: left;
    font-size: 25px;
    font-weight: bold;
    // color: #1868b9;
    letter-spacing:3px;
    text-shadow: 0 0 2px #333,0 0 5px #333,0 0 8px #333;
    // text-shadow: 0 0 2px #fff,
    //             0 0 5px #fff,
    //             0 0 8px #fff,
    //             0 0 11px #fff,
    //             0 0 14px #fff,
    //             0 0 16px #fff,
    //             0 0 20px #fff;
  }
}
.userinfo {
  float: right;
  text-align: right;
  margin-top: 15px;
  span {
    color: @White;
    cursor: pointer;
  }
  .el-icon {
    margin: 0 5px;
    font-size:20px;
    vertical-align:bottom;
  }
  .down {
    font-size: 14px;
    color: #ddd;
  }
}

// body > .el-container {
//   // margin-bottom: 40px;
//   height: 100%;
// }

// .el-container:nth-child(5) .el-aside,
// .el-container:nth-child(6) .el-aside {
//   line-height: 260px;
// }

// .el-container:nth-child(7) .el-aside {
//   line-height: 320px;
// }
</style>
